<template>
  <a-form class="ng-form-style ng-filter" :form="form" layout="inline">
    <a-form-item label="支付类型">
      <a-select
        :options="PayWayOptions"
        v-decorator="['apply_type', {initialValue: defaultData.apply_type || ''}]"
        :style="{width: '120px'}"
      ></a-select>
    </a-form-item>

    <a-form-item label="提现状态">
      <a-select
        :options="DrawingStatusOptions"
        v-decorator="['apply_status', {initialValue: defaultData.apply_status || ''}]"
        :style="{width: '120px'}"
      ></a-select>
    </a-form-item>

    <a-form-item label="申请时间">
      <a-range-picker
        class="w-100"
        valueFormat="YYYY-MM-DD"
        v-decorator="['time', { initialValue: defaultData.time}]"
        :style="{width: '240px'}"
      >
        <a-icon slot="suffixIcon" type="calendar" />
      </a-range-picker>
    </a-form-item>

    <slot name="extra"></slot>
  </a-form>
</template>

<script>
  import {DatePicker} from 'ant-design-vue';

  import {
    SettleWays,
    AddDefaultToOptions,
    DrawingStatusOptions
  } from '@/config/options'

  const PayWayOptions = SettleWays.slice(0, 3);

  export default {
    data() {
      return {
        labelList: [],
        PayWayOptions: AddDefaultToOptions(PayWayOptions, '全部'),
        DrawingStatusOptions: AddDefaultToOptions(DrawingStatusOptions, '全部'),
      }
    },

    props: {
      type: String,
      defaultData: {
        type: Object,
        default() {
          return {}
        }
      },
    },

    components: {
      ARangePicker: DatePicker.RangePicker,
    },

    beforeCreate() {
      this.form = this.$form.createForm(this, {
        onValuesChange: (props, values) => {
          values = Object.assign(values, {page: 1});

          this.$root.$goSearch(values);

          this.$emit('change', values);
        }
      });
    },

    methods: {
    }
  }
</script>

<style lang="scss" scoped>
  .ng-filter {
  }
</style>
